/**
 * @module utils/browser
 * @description 浏览器操作
 * @author caoshitong@moretickets.com
 */

import Cookies from "js-cookie";
// import { APP_AUTH_TOKEN } from "../global/consts";
import EventBus from "./eventbus";
import { AppEventTypeEnum } from "./enums";
const APP_AUTH_TOKEN = 'app_auth_token';
/**
 * @description 打开新页面, 通过模拟点击 a 连接打开新窗口
 * @param {string} url 新页面的URL location.pathname
 * @param {object} params 拼接到生成 location.search
 */
const openNewWindow = (url: any, params = {}) => {
  // console.log(params);
};

/**
 * @description axios 文件下载逻辑
 * @param {object} res - 文件下载返回的response
 * @TODO 待优化
 */
const fileDownload = (res: { data?: any; headers?: any; }) => {
  const blob = res.data;
  const {
    headers: { "content-disposition": disposition },
  } = res;
  const reader = new FileReader();
  reader.readAsDataURL(blob);
  reader.onload = (e) => {
    const fileName = decodeURI(
      // 正则修改
      (disposition.match(/filename=(.*)/)[1] ?? '').replace(/['"]/g, '')
    );
    const elementA = document.createElement("a");
    elementA.download = fileName;
    elementA.href = e.target?.result as string;
    document.body.appendChild(elementA);
    elementA.click();
    document.body.removeChild(elementA);
  };
};

/**
 * @description 去登录页，一般需要带上当前页，用于登录成功之后返回
 * @param {string} loginUrl 登录页的路径
 * @param {object} router 可选属性，如果不传用 window.location.href 进行跳转，传了之后用router push进行跳转提升跳转速度
 */
const toLogin = (loginUrl: any, router: { path: any; }[]) => {
  Cookies.remove(APP_AUTH_TOKEN);
  const toUrl = loginUrl;
  if (!router) {
    window.location.href = toUrl;
  } else {
    router.push({ path: toUrl });
  }
};

/**
 * @param {Route} route 当前路由
 * @param {Array} routeWhiteList 不用检查路由的白名单
 */
const checkLogin = (route: { path: any; }, routeWhiteList: string | any[]) => {
  let result = true;
  const { path } = route;
  if (!routeWhiteList.includes(path)) {
    const authToken = Cookies.get(APP_AUTH_TOKEN);
    if (authToken) {
      result = true;
    } else {
      EventBus.$emit(AppEventTypeEnum.RE_LOGIN);
      result = false;
    }
  }
  return result;
};

/**
 * @description 登录之后根据from 跳到指定页面，实现从哪来回哪儿去
 * @param {string} defaultUrl 没有from跳到系统默认页
 * @param {object} router 路由实例
 */
const toApp = (defaultUrl: any, router: { path: any; }[]) => {
  let appUrl = defaultUrl;
  const { search } = window.location;
  // Cookies.set(APP_AUTH_TOKEN, token);
  const matched = decodeURIComponent(search).match(/from=\[(.*?)\]/);
  if (matched && matched.length === 2) {
    const { 1: matchedUrl } = matched;
    appUrl = matchedUrl;
  }
  if (router) {
    const {
      location: { origin },
    } = window;
    const toPath = appUrl.replace(origin, "");
    router.push({ path: toPath });
  } else {
    window.location.href = appUrl;
  }
};

const WindowResources: any[] = [];
/**
 * @description 动态引入资源，用于单易引入不用编译的js/css 减少编译负担
 * @param {string} src 资源路径
 * @param {function} callback 回调函数，只适用于js
 * @param {boolean} noLoad 跳过加载直接执行回调
 */
const mtlLoadResources = (src: string, callback?: () => void, noLoad?: any) => {
  if (
    WindowResources.includes(src) &&
    callback &&
    typeof callback === "function"
  ) {
    callback();
    return;
  }
  if (noLoad && callback && typeof callback === "function") {
    callback();
    return;
  }

  if (!src) {
    // console.log(new Error("please set the src of script/css"));
    return;
  }
  // load javascript
  if (/\.js(\?v=.*){0,1}$/.test(src)) {
    const script = document.createElement("script");
    script.src = src;
    script.type = "text/javascript";
    const headEle = document.getElementsByTagName("head")[0];

    // IE
    // if (script.readyState) {
    //   script.onreadystatechange = () => {
    //     if (
    //       script.readyState === "loaded" ||
    //       script.readyState === "complete"
    //     ) {
    //       callback();
    //       script.onreadystatechange = null;
    //     }
    //   };
    //   // webkit opera
    // } else {
    script.onload = () => {
      if (callback) callback();
    };
    // }
    headEle.appendChild(script);
    WindowResources.push(src);
    // load stylesheet
  } else if (/\.css$/.test(src)) {
    const styleSheet = document.createElement("link");
    styleSheet.href = src;
    styleSheet.rel = "stylesheet";
    const headEle = document.getElementsByTagName("head")[0];
    headEle.appendChild(styleSheet);
    WindowResources.push(src);
  }
};
// 入参为空的 排除
const filterEmptyParam = (params: { [x: string]: any; }) => {
  const isObj = Object.prototype.toString.call(params) === "[object Object]";
  if (!isObj) {
    return params;
  }
  const data:{ [x: string]: any; } = {};
  Object.keys(params).forEach((item) => {
    const flag = Object.prototype.hasOwnProperty.call(params, item);
    if (
      flag &&
      params[item] !== undefined &&
      params[item] !== "" &&
      params[item] !== null
    ) {
      data[item] = params[item];
    }
  });
  return data;
};

export {
  openNewWindow,
  toLogin,
  toApp,
  checkLogin,
  fileDownload,
  mtlLoadResources,
  filterEmptyParam,
};
